import { TimelineItemDTO } from '../interface/apiModels';
import { TimelineItem } from './useTimeline';

export const convertTimelineItem = (dto: TimelineItemDTO): TimelineItem => {
  return {
    id: dto.id,
    timestamp: new Date(dto.occurredAt),
    type: dto.type,
    message: dto.message,
    relatedPlayerIds: dto.relatedPlayerIds,
    relatedGameId: dto.relatedGameId ?? undefined,
    extra: dto.extra,
  };
};

export const convertTimelineItems = (dtos: TimelineItemDTO[]): TimelineItem[] => {
  if (dtos == null) return [];
  return dtos.map(convertTimelineItem);
};
